import { render } from "./AllSupplierReceipts.vue?vue&type=template&id=0dd1bb14&scoped=true"
import script from "./AllSupplierReceipts.vue?vue&type=script&lang=js"
export * from "./AllSupplierReceipts.vue?vue&type=script&lang=js"

import "./AllSupplierReceipts.vue?vue&type=style&index=0&id=0dd1bb14&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd1bb14"]])

export default __exports__